import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "grid-content ep-bg-purple"
}, null, -1);

const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  id: "music",
  class: "icon",
  width: "50px",
  height: "50px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  class: "svg_p",
  d: "M959.112154 768.5664 959.112154 122.946147c0-32.921807-26.784016-59.705823-59.706847-59.705823L329.374636 63.240323c-32.921807 0-59.706847 26.784016-59.706847 59.705823l0 590.643128c-20.75265-13.34289-45.429679-21.090341-71.882144-21.090341-73.490781 0-133.280516 59.789735-133.280516 133.280516s59.789735 133.280516 133.280516 133.280516c73.490781 0 133.280516-59.789735 133.280516-133.280516L331.066161 124.638695l566.646598 0 0 535.664979c-20.739347-13.31833-45.39284-21.048385-71.818699-21.048385-73.490781 0-133.280516 59.789735-133.280516 133.280516s59.789735 133.280516 133.280516 133.280516 133.280516-59.789735 133.280516-133.280516C959.175599 771.207553 959.150016 769.885442 959.112154 768.5664zM197.785645 897.661593c-39.635719 0-71.882144-32.246425-71.882144-71.882144s32.246425-71.882144 71.882144-71.882144c39.635719 0 71.882144 32.246425 71.882144 71.882144S237.422388 897.661593 197.785645 897.661593zM825.895083 844.417949c-39.635719 0-71.882144-32.246425-71.882144-71.882144s32.246425-71.882144 71.882144-71.882144c38.790468 0 70.483284 30.889521 71.818699 69.360717l0 2.521426c0 0.423649 0.01535 0.843204 0.031722 1.26276C897.067053 812.852022 865.108177 844.417949 825.895083 844.417949z",
  fill: "none"
})], -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "grid-content ep-bg-purple"
}, null, -1);

const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  id: "sing",
  class: "icon",
  width: "50px",
  height: "50px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  class: "svg_p",
  d: "M176.056576 768c-15.36 0-29.184-4.096-40.96-12.8-17.92-13.312-28.672-38.4-31.744-74.24-9.216-98.816 36.864-260.608 142.848-378.88C453.048576 71.68 699.320576-13.824 999.352576 40.448c12.288 2.048 22.016 11.776 24.576 23.552 2.56 12.288-2.56 24.576-12.8 31.744-284.16 190.464-385.024 341.504-474.112 475.136-16.896 25.088-32.256 48.64-49.152 72.192-6.656 9.216-17.408 13.824-28.16 12.8-31.744-3.584-88.576 29.184-107.008 39.424l-1.024 0.512C280.504576 736.256 220.600576 768 176.056576 768z m-3.584-60.416z m-0.512-0.512c2.56 0.512 15.872 2.56 54.784-13.824 30.72-13.312 64.512-32.768 94.208-50.176l1.024-0.512c37.376-21.504 83.968-45.056 125.44-47.616 12.8-18.432 25.6-37.888 38.912-57.856C571.320576 409.6 667.064576 266.24 912.824576 89.6 669.112576 66.048 465.336576 148.992 291.256576 343.04c-134.656 150.016-139.776 339.456-119.296 364.032z",
  fill: "none"
}), /*#__PURE__*/_createElementVNode("path", {
  class: "svg_p",
  d: "M30.648576 980.992c-4.096 0-8.192-1.024-12.288-2.56-15.36-6.656-22.528-24.576-15.872-39.936 155.648-358.4 485.888-620.032 500.224-630.784 13.312-10.24 32.256-8.192 43.008 5.12 10.24 13.312 8.192 32.256-5.12 43.008-3.072 2.56-332.288 263.168-481.792 607.232-5.12 11.264-16.384 17.92-28.16 17.92z",
  fill: "none"
}), /*#__PURE__*/_createElementVNode("path", {
  class: "svg_p",
  d: "M331.192576 537.6h-1.536c-16.896-1.024-29.696-14.848-29.184-31.744l11.776-253.952c1.024-16.896 14.848-29.696 31.744-29.184 16.896 1.024 29.696 14.848 29.184 31.744l-11.776 253.952c-0.512 16.384-13.824 29.184-30.208 29.184zM905.656576 999.424c-3.584 0-7.68-0.512-11.264-2.048-44.032-17.92-68.608-46.592-88.064-69.12-23.04-26.624-35.84-41.984-71.68-40.448-31.232 1.024-50.688 20.992-72.704 44.544-27.648 28.672-61.952 64.512-120.32 51.712-47.616-10.24-71.68-39.936-91.648-63.488-20.992-25.6-35.328-42.496-74.24-42.496h-0.512c-68.096 0.512-142.336 62.464-165.376 86.528-11.776 12.288-30.72 12.8-43.008 1.024-12.288-11.776-12.8-30.72-1.024-43.008 4.096-4.096 101.376-104.448 208.896-104.96h1.024c67.584 0 97.28 35.84 121.344 64.512 17.408 20.992 30.72 37.376 57.856 43.008 23.04 5.12 35.84-5.632 63.488-34.304 26.112-27.136 58.88-61.44 114.688-63.488 65.536-2.56 94.208 31.744 120.32 61.44 17.92 20.48 34.304 39.936 65.024 52.736 15.36 6.144 23.04 24.064 16.896 39.936-6.144 10.752-17.408 17.92-29.696 17.92z",
  fill: "none"
})], -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "grid-content ep-bg-purple"
}, null, -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  d: "blog",
  class: "icon",
  width: "50px",
  height: "50px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  class: "svg_p",
  d: "M143.1 99.8h597.1c44 0 79.6 35.6 79.6 79.6v664c0 44-35.6 79.6-79.6 79.6H143.1c-44 0-79.6-35.6-79.6-79.6v-664c0-44 35.6-79.6 79.6-79.6z",
  fill: "none"
}), /*#__PURE__*/_createElementVNode("path", {
  class: "svg_p",
  d: "M501.3 478.2h-252c-18.3 0-33.2 14.9-33.2 33.2s14.9 33.2 33.2 33.2h252.1c18.3 0 33.2-14.9 33.2-33.2s-14.9-33.2-33.3-33.2zM395.2 650.7H249.3c-18.3 0-33.2 14.9-33.2 33.2 0 18.3 14.9 33.2 33.2 33.2h145.9c18.3 0 33.2-14.9 33.2-33.2 0-18.3-14.9-33.2-33.2-33.2zM634 305.8H249.3c-18.3 0-33.2 14.9-33.2 33.2s14.9 33.2 33.2 33.2H634c18.3 0 33.2-14.9 33.2-33.2s-14.9-33.2-33.2-33.2z",
  fill: "none"
}), /*#__PURE__*/_createElementVNode("path", {
  class: "svg_p",
  d: "M957 475.7c-1.2-6.1-3-12.2-5.4-17.7l-0.1-0.3-0.2-0.3c-5.8-12.7-13.7-24.8-23.7-35.9-10.4-11.6-20.5-19.9-30.6-25.4-5.3-2.8-10.7-5-16.9-6.9-7.3-2.2-14.5-3.4-22-3.8-1.3 0-2.1-0.1-3-0.1-7.7 0-15.4 1.2-23.1 3.6-8.9 2.8-17.6 7.4-25.6 13.9l-0.5 0.4-0.5 0.4c-3.9 3.3-8.5 7.5-13.5 12.4-4.5 4.5-8.4 8.1-11.6 11.2l-3.3 3.2-0.1-0.1-2.4 2.5-25.7 24.5 1 1-2.1 2.2-90.1 93.2-34 35.1-30.6 31.6c-9.4 9.7-17.2 17.8-23.5 24.5l-10.1 10.6-1.4 1.5c-5.8 6-10.6 11.9-14.2 17.7-3 4.7-5.8 10.1-8.3 15.8-2.4 4.8-4.6 10.7-7.4 19.3-2.4 7.3-4.8 15.3-7.3 24.1-2.4 8.3-4.7 16.4-6.8 24.2-2.8 10.2-4.3 17.4-5.2 23.4-2.9 19.2 0.7 35.7 10.8 48.6 6 7.6 19.1 19.7 42.7 19.7 2.9 0 6-0.2 9.2-0.5l0.8-0.1 0.8-0.1c5-0.8 11.4-2.3 20.7-4.8 7.9-2.1 16.3-4.7 25.7-7.8 8.8-3 17.2-6 25.3-9 8.7-3.4 15.3-6.2 20.4-8.7 6.7-3.1 13.1-7.1 19.1-11.9 4-3.1 7.7-6.3 11-9.3 2.8-2.4 6.2-5.8 12.9-12.7 6.1-6.3 13.5-14.1 22.5-23.5 8.1-8.6 17.5-18.2 29.7-30.5l0.3-0.3 0.2-0.3 33.5-35.1 90-93 29.1-30.1-0.1-0.1 0.3-0.3c2.6-2.3 5.4-5 8.3-8 1.8-1.8 3.9-4 6.3-6.3 2.9-2.9 6.1-6.1 9.7-9.8l0.6-0.6 0.6-0.6c6.6-7.4 11.6-15.7 14.9-24.5 3.2-8.5 4.8-17.5 4.8-26.5 0.1-6.7-0.6-13.3-1.9-19.7z",
  fill: "none"
}), /*#__PURE__*/_createElementVNode("path", {
  class: "svg_p",
  d: "M765.2 665.3l-33.5 35.1c-11.1 11.3-21.2 21.6-30.2 31-8.9 9.4-16.3 17.1-22.2 23.2-5.9 6.1-9.4 9.5-10.5 10.4-2.8 2.6-6 5.4-9.6 8.2-3.6 2.9-7.4 5.2-11.3 7-3.9 2-9.6 4.4-17.2 7.4-7.6 2.9-15.4 5.7-23.7 8.4-8.2 2.7-16.1 5.1-23.5 7.1-7.4 2-12.9 3.3-16.6 3.9-1.6 0.2-3.2 0.3-4.5 0.3-5 0-8.6-1.2-10.5-3.7-2.5-3.2-3.2-8.5-2.1-16 0.6-4.1 1.9-9.9 4-17.6 2.1-7.7 4.3-15.6 6.7-23.8 2.4-8.3 4.7-15.9 6.9-22.8s4.1-11.7 5.5-14.3c1.7-4 3.6-7.7 5.7-11s5.1-7 9-11c1.7-1.8 5.6-5.9 11.8-12.4 6.1-6.5 13.8-14.5 23.1-24.1l30.6-31.6 34-35.1 90.1-93.2 78.4 81.5-90.4 93.1z m150.5-158.6c-1.4 3.8-3.6 7.4-6.7 10.8-3.3 3.5-6.4 6.5-9 9.1l-6.9 6.9c-2.2 2.3-4.3 4.3-6.3 6.1l-78.4-81c3.4-3.2 7.4-7 11.9-11.5 4.6-4.5 8.5-8 11.5-10.6 3.9-3.1 8-5.4 12.1-6.7 3.8-1.2 7.5-1.8 11.2-1.8h1.2c4 0.2 8 0.8 11.7 1.9 3.8 1.2 7.1 2.5 9.8 3.9 5.9 3.2 12.4 8.7 19.5 16.6 7.1 7.9 12.6 16.3 16.6 24.9 1.1 2.6 2 5.6 2.7 9.1 0.7 3.5 1.1 7.1 1.1 10.8 0.1 3.9-0.6 7.7-2 11.5z",
  fill: "none"
})], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, {
    gutter: 10,
    class: "nav_bar"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_1, _createVNode(_component_router_link, {
        to: "/",
        onClick: $setup.clickBtn
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_3, _createVNode(_component_router_link, {
        to: "/shici",
        onClick: $setup.clickBtn
      }, {
        default: _withCtx(() => [_hoisted_4]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_5, _createVNode(_component_router_link, {
        to: "/blog",
        onClick: $setup.clickBtn
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_router_view)], 64);
}